import { Card, Row, Spin, Typography, Upload } from 'antd';
import React from 'react';
import '../index.css';
import './BoxImage.css';

const formatosImagen = 'image/jpeg,image/heif,image/heic';

const BoxImage = ({
  card,
  customRequest,
  beforeUpload,
  disabled,
  loading,
  imagen
}) => {
  return (
    <>
      <div style={{ padding: 12 }}>
        <Typography.Title level={5} style={{ textAlign: 'center' }}>
          {card.parte}
        </Typography.Title>
        <Typography.Paragraph style={{ textAlign: 'center' }}>
          {card.parteDescripcion}
        </Typography.Paragraph>
      </div>
      <Row justify="center">
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosImagen}
          showUploadList={false}
          customRequest={customRequest}
          beforeUpload={beforeUpload}
          disabled={disabled}
          capture="environment"
        >
          <div style={{ padding: 2 }}>
            <Spin spinning={loading}>
              <Card
                cover={
                  <img
                    style={{
                      minWidth: 240,
                      height: 340,
                      objectFit: 'contain'
                    }}
                    alt={card.parte}
                    src={imagen}
                  />
                }
                bodyStyle={{ padding: 0 }}
                style={{
                  border: 0,
                  marginBottom: 20
                }}
              />
            </Spin>

            <div className="background-hover" />
          </div>
        </Upload>
      </Row>
    </>
  );
};

export default BoxImage;
